// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terminal_modal {
    display: none;
    position: absolute;
    inset: 0;
    z-index: 1000;
    flex-direction: column;
    background: #0d0d0d;
    /* Override VKB's activity-bar bottom offset — no activity bar in fullscreen modal */
    --vkb-bottom: 0;
    /* Contain the absolute-positioned mobile screens */
    overflow: hidden;
}

/* Touch/mobile: use fixed so it covers the whole viewport */
@media (pointer: coarse) {
    .terminal_modal {
        position: fixed;
    }
}

.terminal_modal--open {
    display: flex;
}

.terminal_modal__toolbar {
    display: flex;
    align-items: center;
    gap: 4px;
    height: 40px;
    padding: 0 8px;
    background: var(--color-bg, #1a1a1a);
    border-bottom: 1px solid var(--color-border, #333);
    flex-shrink: 0;
}

.terminal_modal__title {
    font-size: 12px;
    color: var(--color-text-muted);
    font-family: "JetBrains Mono", "Fira Code", Menlo, monospace;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.terminal_modal__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 4px;
    border: 1px solid transparent;
    background: transparent;
    color: var(--color-text-muted);
    font-size: 14px;
    cursor: pointer;
    transition: background 0.1s, color 0.1s;
    flex-shrink: 0;
}

.terminal_modal__btn--label {
    width: auto;
    padding: 0 7px;
    font-family: "JetBrains Mono", "Fira Code", Menlo, monospace;
    font-size: 11px;
    letter-spacing: 0.03em;
}

.terminal_modal__btn--active {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: #333;
}

@media (pointer: fine) {
    .terminal_modal__btn:hover {
        background: var(--color-bg-hover, rgba(255,255,255,0.08));
        color: var(--color-text, #fff);
    }
}

/* Floating @ button inside terminal content area */

.terminal_modal__context_btn {
    position: absolute;
    bottom: 12px;
    right: 12px;
    width: 28px;
    height: 28px;
    border-radius: 4px;
    border: 1px solid rgba(255,255,255,0.15);
    background: rgba(13,13,13,0.85);
    color: var(--color-text-muted, #888);
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.1s, color 0.1s, border-color 0.1s;
    z-index: 10;
}

.terminal_modal__context_btn--active {
    background: color-mix(in srgb, var(--color-accent, #4a6cf7) 20%, rgba(13,13,13,0.85));
    border-color: color-mix(in srgb, var(--color-accent, #4a6cf7) 60%, transparent);
    color: var(--color-accent, #4a6cf7);
}

@media (pointer: fine) {
    .terminal_modal__context_btn:hover {
        background: rgba(255,255,255,0.1);
        color: var(--color-text, #fff);
        border-color: rgba(255,255,255,0.3);
    }

    .terminal_modal__context_btn--active:hover {
        background: color-mix(in srgb, var(--color-accent, #4a6cf7) 30%, rgba(13,13,13,0.85));
    }
}

/* Body — wraps agent pane and terminal side by side */

.terminal_modal__body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: row;
}

/* ── Agent pane ─────────────────────────────────────────── */

.terminal_modal__agent {
    display: flex;
    flex-direction: column;
    width: 300px;
    flex-shrink: 0;
    border-left: 1px solid #2a2a2a;
    background: #0d0d0d;
    font-family: "JetBrains Mono", "Fira Code", Menlo, monospace;
    font-size: 12px;
    min-height: 0;
}

.terminal_modal__agent--hidden {
    display: none;
}

.terminal_modal__agent_history {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 12px 14px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    scrollbar-width: thin;
    scrollbar-color: #2a2a2a transparent;
}

.terminal_modal__agent_empty {
    display: flex;
    flex-direction: column;
    gap: 3px;
    color: #3a3a3a;
    font-size: 11px;
    font-style: italic;
    padding: 2px 0;
}

.terminal_modal__agent_msg {
    display: flex;
    gap: 8px;
    line-height: 1.55;
}

.terminal_modal__agent_msg_prefix {
    flex-shrink: 0;
    font-weight: 700;
    line-height: 1.55;
}

.terminal_modal__agent_msg--user .terminal_modal__agent_msg_prefix {
    color: #4ec994;
}

.terminal_modal__agent_msg--assistant .terminal_modal__agent_msg_prefix {
    color: #555;
}

.terminal_modal__agent_msg--user .terminal_modal__agent_msg_text {
    color: #d4d4d4;
}

.terminal_modal__agent_msg--assistant .terminal_modal__agent_msg_text {
    color: #909090;
}

.terminal_modal__agent_msg_text {
    white-space: pre-wrap;
    word-break: break-word;
}

.terminal_modal__agent_input_row {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 10px;
    border-top: 1px solid #1e1e1e;
    background: #101010;
}

.terminal_modal__agent_prompt {
    flex-shrink: 0;
    color: #4ec994;
    font-family: "JetBrains Mono", "Fira Code", Menlo, monospace;
    font-size: 14px;
    line-height: 1;
    user-select: none;
}

/* TextInput overrides — terminal look inside agent input row */

.terminal_modal__agent_input_row .text_input__touch_wrapper {
    flex: 1;
    min-width: 0;
}

.terminal_modal__agent_input_row .text_input {
    flex: 1;
    min-width: 0;
    background: transparent;
    border: none;
    border-radius: 0;
    color: #d4d4d4;
    font-family: "JetBrains Mono", "Fira Code", Menlo, monospace;
    font-size: 12px;
    padding: 0;
    caret-color: #4ec994;
}

.terminal_modal__agent_input_row .text_input::placeholder {
    color: #333;
}

.terminal_modal__agent_input_row .text_input:focus,
.terminal_modal__agent_input_row .text_input--vkb-active {
    border-color: transparent;
}

.terminal_modal__agent_input_row .text_input__cursor_overlay {
    padding: 0;
    font-family: "JetBrains Mono", "Fira Code", Menlo, monospace;
    font-size: 12px;
    color: #d4d4d4;
}


.terminal_modal__agent_send {
    flex-shrink: 0;
    padding: 3px 10px;
    background: transparent;
    border: 1px solid #2a2a2a;
    border-radius: 3px;
    color: #4ec994;
    font-family: "JetBrains Mono", "Fira Code", Menlo, monospace;
    font-size: 11px;
    cursor: pointer;
    transition: border-color 0.15s, color 0.15s;
}

@media (pointer: fine) {
    .terminal_modal__agent_send:hover:not(:disabled) {
        border-color: #4ec994;
        color: #6ddaaa;
    }
}

.terminal_modal__agent_send:disabled {
    opacity: 0.25;
    cursor: default;
}

/* Suggestion card */

.terminal_modal__suggestion {
    display: flex;
    flex-direction: column;
    gap: 5px;
    background: #141414;
    border: 1px solid #2a2a2a;
    border-radius: 4px;
    padding: 9px 11px;
}

.terminal_modal__suggestion_command {
    display: flex;
    align-items: baseline;
    gap: 6px;
}

.terminal_modal__suggestion_dollar {
    color: #4ec994;
    font-weight: 700;
    flex-shrink: 0;
}

.terminal_modal__suggestion_cmd {
    color: #d4d4d4;
    white-space: pre-wrap;
    word-break: break-all;
    flex: 1;
}

.terminal_modal__suggestion_explanation {
    color: #666;
    font-size: 11px;
    line-height: 1.45;
}

.terminal_modal__suggestion_apply {
    align-self: flex-end;
    padding: 3px 10px;
    background: transparent;
    border: 1px solid #2a6644;
    border-radius: 3px;
    color: #4ec994;
    font-family: "JetBrains Mono", "Fira Code", Menlo, monospace;
    font-size: 11px;
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s;
}

@media (pointer: fine) {
    .terminal_modal__suggestion_apply:hover {
        border-color: #4ec994;
        background: rgba(78, 201, 148, 0.08);
    }
}

/* Thinking indicator */

.terminal_modal__agent_thinking {
    color: #3a3a3a;
    font-size: 11px;
    font-style: italic;
}

/* Mobile: fullscreen screens, one visible at a time */

.terminal_modal__screen {
    display: none;
    position: absolute;
    inset: 0;
    flex-direction: column;
    background: #0d0d0d;
}

.terminal_modal__screen--active {
    display: flex;
}

@media (pointer: coarse) {
    .terminal_modal__agent {
        width: 100%;
        border-left: none;
        flex: 1;
        min-height: 0;
    }
}

.terminal_modal__content {
    flex: 1;
    overflow: hidden;
    padding: 4px;
    box-sizing: border-box;
    /* Flex column so the VKB spacer div pushes the xterm container up */
    display: flex;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
    position: relative;
}

/* xterm.js container — fills remaining space after the VKB spacer */
.terminal_modal__xterm {
    width: 100%;
    flex: 1;
    min-height: 0;
}

/* xterm.js injects its own styles; these override the background only */
.terminal_modal__xterm .xterm {
    height: 100%;
}

.terminal_modal__xterm .xterm-viewport {
    overflow-y: auto !important;
}

/* Override VKB landscape left-offset (normally accounts for activity bar, not present here) */
@media (orientation: landscape) and (max-height: 500px) {
    .terminal_modal .vkb {
        left: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./components/sections/DeploymentSection/TerminalModal/s.terminal_modal.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,oFAAoF;IACpF,eAAe;IACf,mDAAmD;IACnD,gBAAgB;AACpB;;AAEA,4DAA4D;AAC5D;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,cAAc;IACd,oCAAoC;IACpC,kDAAkD;IAClD,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,4DAA4D;IAC5D,OAAO;IACP,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,uBAAuB;IACvB,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,4DAA4D;IAC5D,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI;QACI,yDAAyD;QACzD,8BAA8B;IAClC;AACJ;;AAEA,mDAAmD;;AAEnD;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,+BAA+B;IAC/B,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0DAA0D;IAC1D,WAAW;AACf;;AAEA;IACI,qFAAqF;IACrF,+EAA+E;IAC/E,mCAAmC;AACvC;;AAEA;IACI;QACI,iCAAiC;QACjC,8BAA8B;QAC9B,mCAAmC;IACvC;;IAEA;QACI,qFAAqF;IACzF;AACJ;;AAEA,sDAAsD;;AAEtD;IACI,OAAO;IACP,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;AAEA,8DAA8D;;AAE9D;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,cAAc;IACd,8BAA8B;IAC9B,mBAAmB;IACnB,4DAA4D;IAC5D,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,4DAA4D;IAC5D,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA,+DAA+D;;AAE/D;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,4DAA4D;IAC5D,eAAe;IACf,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,4DAA4D;IAC5D,eAAe;IACf,cAAc;AAClB;;;AAGA;IACI,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,4DAA4D;IAC5D,eAAe;IACf,eAAe;IACf,2CAA2C;AAC/C;;AAEA;IACI;QACI,qBAAqB;QACrB,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA,oBAAoB;;AAEpB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,OAAO;AACX;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,4DAA4D;IAC5D,eAAe;IACf,eAAe;IACf,gDAAgD;AACpD;;AAEA;IACI;QACI,qBAAqB;QACrB,oCAAoC;IACxC;AACJ;;AAEA,uBAAuB;;AAEvB;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA,sDAAsD;;AAEtD;IACI,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;QACX,iBAAiB;QACjB,OAAO;QACP,aAAa;IACjB;AACJ;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,oEAAoE;IACpE,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,kBAAkB;AACtB;;AAEA,oEAAoE;AACpE;IACI,WAAW;IACX,OAAO;IACP,aAAa;AACjB;;AAEA,wEAAwE;AACxE;IACI,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,8FAA8F;AAC9F;IACI;QACI,OAAO;IACX;AACJ","sourcesContent":[".terminal_modal {\n    display: none;\n    position: absolute;\n    inset: 0;\n    z-index: 1000;\n    flex-direction: column;\n    background: #0d0d0d;\n    /* Override VKB's activity-bar bottom offset — no activity bar in fullscreen modal */\n    --vkb-bottom: 0;\n    /* Contain the absolute-positioned mobile screens */\n    overflow: hidden;\n}\n\n/* Touch/mobile: use fixed so it covers the whole viewport */\n@media (pointer: coarse) {\n    .terminal_modal {\n        position: fixed;\n    }\n}\n\n.terminal_modal--open {\n    display: flex;\n}\n\n.terminal_modal__toolbar {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    height: 40px;\n    padding: 0 8px;\n    background: var(--color-bg, #1a1a1a);\n    border-bottom: 1px solid var(--color-border, #333);\n    flex-shrink: 0;\n}\n\n.terminal_modal__title {\n    font-size: 12px;\n    color: var(--color-text-muted);\n    font-family: \"JetBrains Mono\", \"Fira Code\", Menlo, monospace;\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.terminal_modal__btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    border-radius: 4px;\n    border: 1px solid transparent;\n    background: transparent;\n    color: var(--color-text-muted);\n    font-size: 14px;\n    cursor: pointer;\n    transition: background 0.1s, color 0.1s;\n    flex-shrink: 0;\n}\n\n.terminal_modal__btn--label {\n    width: auto;\n    padding: 0 7px;\n    font-family: \"JetBrains Mono\", \"Fira Code\", Menlo, monospace;\n    font-size: 11px;\n    letter-spacing: 0.03em;\n}\n\n.terminal_modal__btn--active {\n    background: rgba(255, 255, 255, 0.1);\n    color: #fff;\n    border-color: #333;\n}\n\n@media (pointer: fine) {\n    .terminal_modal__btn:hover {\n        background: var(--color-bg-hover, rgba(255,255,255,0.08));\n        color: var(--color-text, #fff);\n    }\n}\n\n/* Floating @ button inside terminal content area */\n\n.terminal_modal__context_btn {\n    position: absolute;\n    bottom: 12px;\n    right: 12px;\n    width: 28px;\n    height: 28px;\n    border-radius: 4px;\n    border: 1px solid rgba(255,255,255,0.15);\n    background: rgba(13,13,13,0.85);\n    color: var(--color-text-muted, #888);\n    font-size: 14px;\n    font-weight: 700;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.1s, color 0.1s, border-color 0.1s;\n    z-index: 10;\n}\n\n.terminal_modal__context_btn--active {\n    background: color-mix(in srgb, var(--color-accent, #4a6cf7) 20%, rgba(13,13,13,0.85));\n    border-color: color-mix(in srgb, var(--color-accent, #4a6cf7) 60%, transparent);\n    color: var(--color-accent, #4a6cf7);\n}\n\n@media (pointer: fine) {\n    .terminal_modal__context_btn:hover {\n        background: rgba(255,255,255,0.1);\n        color: var(--color-text, #fff);\n        border-color: rgba(255,255,255,0.3);\n    }\n\n    .terminal_modal__context_btn--active:hover {\n        background: color-mix(in srgb, var(--color-accent, #4a6cf7) 30%, rgba(13,13,13,0.85));\n    }\n}\n\n/* Body — wraps agent pane and terminal side by side */\n\n.terminal_modal__body {\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: row;\n}\n\n/* ── Agent pane ─────────────────────────────────────────── */\n\n.terminal_modal__agent {\n    display: flex;\n    flex-direction: column;\n    width: 300px;\n    flex-shrink: 0;\n    border-left: 1px solid #2a2a2a;\n    background: #0d0d0d;\n    font-family: \"JetBrains Mono\", \"Fira Code\", Menlo, monospace;\n    font-size: 12px;\n    min-height: 0;\n}\n\n.terminal_modal__agent--hidden {\n    display: none;\n}\n\n.terminal_modal__agent_history {\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n    padding: 12px 14px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    scrollbar-width: thin;\n    scrollbar-color: #2a2a2a transparent;\n}\n\n.terminal_modal__agent_empty {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    color: #3a3a3a;\n    font-size: 11px;\n    font-style: italic;\n    padding: 2px 0;\n}\n\n.terminal_modal__agent_msg {\n    display: flex;\n    gap: 8px;\n    line-height: 1.55;\n}\n\n.terminal_modal__agent_msg_prefix {\n    flex-shrink: 0;\n    font-weight: 700;\n    line-height: 1.55;\n}\n\n.terminal_modal__agent_msg--user .terminal_modal__agent_msg_prefix {\n    color: #4ec994;\n}\n\n.terminal_modal__agent_msg--assistant .terminal_modal__agent_msg_prefix {\n    color: #555;\n}\n\n.terminal_modal__agent_msg--user .terminal_modal__agent_msg_text {\n    color: #d4d4d4;\n}\n\n.terminal_modal__agent_msg--assistant .terminal_modal__agent_msg_text {\n    color: #909090;\n}\n\n.terminal_modal__agent_msg_text {\n    white-space: pre-wrap;\n    word-break: break-word;\n}\n\n.terminal_modal__agent_input_row {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 10px;\n    border-top: 1px solid #1e1e1e;\n    background: #101010;\n}\n\n.terminal_modal__agent_prompt {\n    flex-shrink: 0;\n    color: #4ec994;\n    font-family: \"JetBrains Mono\", \"Fira Code\", Menlo, monospace;\n    font-size: 14px;\n    line-height: 1;\n    user-select: none;\n}\n\n/* TextInput overrides — terminal look inside agent input row */\n\n.terminal_modal__agent_input_row .text_input__touch_wrapper {\n    flex: 1;\n    min-width: 0;\n}\n\n.terminal_modal__agent_input_row .text_input {\n    flex: 1;\n    min-width: 0;\n    background: transparent;\n    border: none;\n    border-radius: 0;\n    color: #d4d4d4;\n    font-family: \"JetBrains Mono\", \"Fira Code\", Menlo, monospace;\n    font-size: 12px;\n    padding: 0;\n    caret-color: #4ec994;\n}\n\n.terminal_modal__agent_input_row .text_input::placeholder {\n    color: #333;\n}\n\n.terminal_modal__agent_input_row .text_input:focus,\n.terminal_modal__agent_input_row .text_input--vkb-active {\n    border-color: transparent;\n}\n\n.terminal_modal__agent_input_row .text_input__cursor_overlay {\n    padding: 0;\n    font-family: \"JetBrains Mono\", \"Fira Code\", Menlo, monospace;\n    font-size: 12px;\n    color: #d4d4d4;\n}\n\n\n.terminal_modal__agent_send {\n    flex-shrink: 0;\n    padding: 3px 10px;\n    background: transparent;\n    border: 1px solid #2a2a2a;\n    border-radius: 3px;\n    color: #4ec994;\n    font-family: \"JetBrains Mono\", \"Fira Code\", Menlo, monospace;\n    font-size: 11px;\n    cursor: pointer;\n    transition: border-color 0.15s, color 0.15s;\n}\n\n@media (pointer: fine) {\n    .terminal_modal__agent_send:hover:not(:disabled) {\n        border-color: #4ec994;\n        color: #6ddaaa;\n    }\n}\n\n.terminal_modal__agent_send:disabled {\n    opacity: 0.25;\n    cursor: default;\n}\n\n/* Suggestion card */\n\n.terminal_modal__suggestion {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    background: #141414;\n    border: 1px solid #2a2a2a;\n    border-radius: 4px;\n    padding: 9px 11px;\n}\n\n.terminal_modal__suggestion_command {\n    display: flex;\n    align-items: baseline;\n    gap: 6px;\n}\n\n.terminal_modal__suggestion_dollar {\n    color: #4ec994;\n    font-weight: 700;\n    flex-shrink: 0;\n}\n\n.terminal_modal__suggestion_cmd {\n    color: #d4d4d4;\n    white-space: pre-wrap;\n    word-break: break-all;\n    flex: 1;\n}\n\n.terminal_modal__suggestion_explanation {\n    color: #666;\n    font-size: 11px;\n    line-height: 1.45;\n}\n\n.terminal_modal__suggestion_apply {\n    align-self: flex-end;\n    padding: 3px 10px;\n    background: transparent;\n    border: 1px solid #2a6644;\n    border-radius: 3px;\n    color: #4ec994;\n    font-family: \"JetBrains Mono\", \"Fira Code\", Menlo, monospace;\n    font-size: 11px;\n    cursor: pointer;\n    transition: border-color 0.15s, background 0.15s;\n}\n\n@media (pointer: fine) {\n    .terminal_modal__suggestion_apply:hover {\n        border-color: #4ec994;\n        background: rgba(78, 201, 148, 0.08);\n    }\n}\n\n/* Thinking indicator */\n\n.terminal_modal__agent_thinking {\n    color: #3a3a3a;\n    font-size: 11px;\n    font-style: italic;\n}\n\n/* Mobile: fullscreen screens, one visible at a time */\n\n.terminal_modal__screen {\n    display: none;\n    position: absolute;\n    inset: 0;\n    flex-direction: column;\n    background: #0d0d0d;\n}\n\n.terminal_modal__screen--active {\n    display: flex;\n}\n\n@media (pointer: coarse) {\n    .terminal_modal__agent {\n        width: 100%;\n        border-left: none;\n        flex: 1;\n        min-height: 0;\n    }\n}\n\n.terminal_modal__content {\n    flex: 1;\n    overflow: hidden;\n    padding: 4px;\n    box-sizing: border-box;\n    /* Flex column so the VKB spacer div pushes the xterm container up */\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    min-width: 0;\n    position: relative;\n}\n\n/* xterm.js container — fills remaining space after the VKB spacer */\n.terminal_modal__xterm {\n    width: 100%;\n    flex: 1;\n    min-height: 0;\n}\n\n/* xterm.js injects its own styles; these override the background only */\n.terminal_modal__xterm .xterm {\n    height: 100%;\n}\n\n.terminal_modal__xterm .xterm-viewport {\n    overflow-y: auto !important;\n}\n\n/* Override VKB landscape left-offset (normally accounts for activity bar, not present here) */\n@media (orientation: landscape) and (max-height: 500px) {\n    .terminal_modal .vkb {\n        left: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
